import PropTypes from 'prop-types';

// material-ui
import { Box, Tooltip, Typography, Stack, MenuItem } from '@mui/material';

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import AccessAlarmsTwoToneIcon from '@mui/icons-material/AccessAlarmsTwoTone';
import DoneTwoToneIcon from '@mui/icons-material/DoneTwoTone';
// import DoneAllTwoToneIcon from '@mui/icons-material/DoneAllTwoTone';
import DoNotDisturbOnTwoToneIcon from '@mui/icons-material/DoNotDisturbOnTwoTone';
import PausePresentationTwoToneIcon from '@mui/icons-material/PausePresentationTwoTone';
import PriceCheckTwoToneIcon from '@mui/icons-material/PriceCheckTwoTone';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import StartTwoToneIcon from '@mui/icons-material/StartTwoTone';
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import SettingsBackupRestoreTwoToneIcon from '@mui/icons-material/SettingsBackupRestoreTwoTone';
import UndoTwoToneIcon from '@mui/icons-material/UndoTwoTone';

export const RENDER_WORKFLOW_TRANSITION_FORMAT0 = 0;
export const RENDER_WORKFLOW_TRANSITION_FORMAT1 = 1;

// ==============================|| RENDER WORKFLOW TRANSITION ||============================== //

const RenderWorkflowTransition = ({
    value = '',
    onClickRowActionTransition = () => {},
    renderFormat = RENDER_WORKFLOW_TRANSITION_FORMAT0,
    ...others
}) => {
    if (!value) return <Box {...others} />;

    switch (renderFormat) {
        case RENDER_WORKFLOW_TRANSITION_FORMAT0:
            return (
                <Tooltip title={<FormattedMessage id={`workflow-transition-${value || ''}`} />}>
                    <Typography
                        variant="inherit"
                        color="inherit"
                        sx={{
                            overflow: 'hidden',
                            display: 'block',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        <FormattedMessage id={`workflow-transition-${value || ''}`} />
                    </Typography>
                </Tooltip>
            );
        case RENDER_WORKFLOW_TRANSITION_FORMAT1:
            return (
                <MenuItem
                    onClick={() => {
                        if (typeof onClickRowActionTransition === 'function') {
                            onClickRowActionTransition(value);
                        }
                    }}
                    {...others}
                >
                    <Stack direction="row" spacing={1}>
                        {value === 'start' && <StartTwoToneIcon fontSize="small" />}
                        {value === 'delay' && <AccessAlarmsTwoToneIcon fontSize="small" />}
                        {value === 'reschedule' && <EventTwoToneIcon fontSize="small" />}
                        {value === 'complete' && <DoneTwoToneIcon fontSize="small" />}
                        {value === 'award' && <PriceCheckTwoToneIcon fontSize="small" />}
                        {/* value === 'approve' && <DoneAllTwoToneIcon fontSize="small" /> */}
                        {value === 'reject' && <DoNotDisturbOnTwoToneIcon fontSize="small" />}
                        {value === 'pause' && <PausePresentationTwoToneIcon fontSize="small" />}
                        {value === 'cancel' && <CancelTwoToneIcon fontSize="small" />}
                        {value === 'rectify' && <SettingsBackupRestoreTwoToneIcon fontSize="small" />}
                        {value === 'return_created' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_rescheduled' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_running' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_delayed' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_completed' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_approved' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_awarded' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_rejected' && <UndoTwoToneIcon fontSize="small" />}
                        {value === 'return_rectifying' && <UndoTwoToneIcon fontSize="small" />}
                        <FormattedMessage id={`workflow-transition-${value || ''}`} />
                    </Stack>
                </MenuItem>
            );
        default:
            return <Box {...others} />;
    }
};

RenderWorkflowTransition.propTypes = {
    value: PropTypes.string,
    onClickRowActionTransition: PropTypes.func,
    renderFormat: PropTypes.oneOf([RENDER_WORKFLOW_TRANSITION_FORMAT0, RENDER_WORKFLOW_TRANSITION_FORMAT1])
};

export default RenderWorkflowTransition;
